<template>
  <div>
    <h2>
      Volume
    </h2>
    <el-form
      ref="form"
      :model="item"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Minimum"
            prop="volume_min"
          >
            <el-input
              v-model="item.volume_min"
              type="number"
              placeholder="Minimum"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Maximum"
            prop="volume_max"
          >
            <el-input
              v-model="item.volume_max"
              type="number"
              placeholder="Maximum"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }

  },
  data () {
    return {
      rules: {
        volume_min: [
          { required: true, message: 'Volume Minimum is required.', trigger: ['blur'] }
        ],
        volume_max: [
          { required: true, message: 'Volume Maximum is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
